import { Show, useShowContext } from 'framework/show';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { WASTE_STATUS, useProjectFinanceService, useNewProjectUrl } from 'domain/shared/newProject';
import { Button } from 'framework/ui/mui-builder';
import { Modal } from 'framework/ui/ui-builder';
import { ModalForm, TextArea } from 'framework/form';
import { Box } from '@mui/material';
import { useWasteService } from 'domain/shared/waste';
import ViewWasteContent from './ViewWasteContent';
import ApproveProjectWasteButton from './ApproveProjectWasteButton';

const PreviewWastePageButtons = () => {
  const { data } = useShowContext();
  const { rejectWaste } = useWasteService();
  const { getFinanceUrl, getUpdateWasteUrl } = useNewProjectUrl();
  const { getWasteRejectValidationSchema } = useProjectFinanceService();
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);

  const projectId = data?.davinciProjectId;
  const wasteId = data?.id;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1, mt: 0 }}>
      {data?.status === WASTE_STATUS.REGISTERED && wasteId && (
        <>
          <ApproveProjectWasteButton statusSource="status" id={wasteId} projectId={projectId} />
          <Button variant="outlined" onClick={() => setModalOpen(true)}>
            Reject
          </Button>
          <Modal isOpen={modalOpen} onToggle={() => setModalOpen(false)} title="Reason for rejection">
            <ModalForm
              closeModal={() => setModalOpen(false)}
              modalOpen={modalOpen}
              submitFormFunc={values => rejectWaste(wasteId, values.reason)}
              getValidationSchemaFunc={getWasteRejectValidationSchema}
              afterSubmit={{
                redirect: getFinanceUrl(projectId),
                message: 'You are awesome! Rejection was done.',
              }}
            >
              <TextArea source="reason" label="" placeholder="Please, provide reason here" />
            </ModalForm>
          </Modal>
        </>
      )}
      {data?.status === WASTE_STATUS.DRAFT && (
        <Box gap={1} display="flex">
          <Button variant="outlined" onClick={() => navigate(getFinanceUrl(projectId))}>
            Cancel
          </Button>
          <Button variant="contained" onClick={() => wasteId && navigate(getUpdateWasteUrl(projectId, wasteId))}>
            Edit
          </Button>
        </Box>
      )}
    </Box>
  );
};

const PreviewWastePage = () => {
  const { getById } = useWasteService();
  const { wasteId } = useParams<{ wasteId: string }>();

  return (
    <Box
      sx={{
        '.page-content': {
          minHeight: 0,
        },
      }}
    >
      <Show getDataMethod={() => getById(wasteId!, true)}>
        <ViewWasteContent />
        <PreviewWastePageButtons />
      </Show>
    </Box>
  );
};

export default PreviewWastePage;
